import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import { Company } from 'app/models/company.model';
import { GeneralReport } from 'app/models/general-report.model';
import { CompanyService } from 'app/services/company.service';
import { ExcelService } from 'app/services/excel.service';
import { GeneralReportService } from 'app/services/general-report.service';
import { ApexAxisChartSeries, ApexChart, ApexDataLabels, ApexFill, ApexLegend, ApexPlotOptions, ApexStroke, ApexTheme, ApexTitleSubtitle, ApexTooltip, ApexXAxis, ApexYAxis, ChartComponent } from 'ng-apexcharts';
import { NgxSpinnerService } from 'ngx-spinner';

export type ChartOptions = {
    series: ApexAxisChartSeries;
    chart: ApexChart;
    xaxis: ApexXAxis;
    stroke: ApexStroke;
    fill:ApexFill;
    tooltip:ApexTooltip;
    plotOptions: ApexPlotOptions;
    theme: ApexTheme;
    dataLabels: ApexDataLabels;
    yaxis: ApexYAxis;
    title: ApexTitleSubtitle;
    labels: string[];
    legend: ApexLegend;
    subtitle: ApexTitleSubtitle;
  };
  

@Component({
    selector: 'simulation-general-report-list',
    templateUrl: './simulation-general-report-list.component.html',
    styleUrls: ['./simulation-general-report-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    providers: [ExcelService]
})
export class SimulationGeneralReportListComponent implements OnInit {

    @ViewChild(MatSort) private _sort: MatSort;
    @ViewChild(MatPaginator) private _paginator: MatPaginator;

    @ViewChild("chartCost") chartCost: ChartComponent;
    public chartOptionsCost: Partial<ChartOptions>;

    @ViewChild("chartProductivity") chartProductivity: ChartComponent;
    public chartOptionsProductivity: Partial<ChartOptions>;

    public tableLoading = false;
    public selectByFilter = "year"
    public StartTime: Date;
    public EndTime: Date
    public companyId:number;
    public rootCompanyId:number;

    
    public widgetTotalSaving = 0;
    public widgetOptimizeCost = 0;
    public widgetBaseCost = 0;
    public widgetTotalContainer = 0;
    public widgetTotalOptimize = 0;
    
    private _companies : Array<Company> = [];
    public get companies() : Array<Company> {
        return this._companies;
    }
    public set companies(v : Array<Company>) {
        this._companies = v;
    }
    
    private _filterText: string = '';
    public get filterText(): string {
        return this._filterText;
    }
    public set filterText(v: string) {
        this._filterText = v.trim().toLowerCase();
        this._dataSource.filter = this._filterText;
    }
    
    
    public _generalReport: Array<GeneralReport>
    
    private _dataSource: MatTableDataSource<GeneralReport> = undefined;
    public get dataSource(): MatTableDataSource<GeneralReport> {
        return this._dataSource;
    }

    private _displayedColumns = [
        'created_at',
        'totalPolygonCount', 
        'totalContainerCount',
        'totalOptimizeCount', 
        'totalTransactionContainerCount', 
        'totalTransactionContainerCount2',
        'totalBaseRouteKm',
        "totalOptimizeRouteKm",
        "totalMileageSavings",
        "totalTimeSavings",
        "productivity",
        "totalBaseCost",
        "totalOptimizeCost",
        "totalMileageSavingsCost",
        "totalTimeSavingsCost",
        "totalSavingTotal"];

    public get displayedColumns(): Array<string> {
        return this._displayedColumns;
    }

    constructor(
        private _generalReportService: GeneralReportService,
        private _companyService: CompanyService,
        private _datePipe:DatePipe,
        private router:Router,
        private _excelService: ExcelService,
        private _spinner:NgxSpinnerService,
    ) {
        this.rootCompanyId = parseInt(localStorage.getItem("CompanyID"));
        this.chartOptionsCost = {
            series: [
                {
                  name: "Toplam Tasarruf",
                  data: [0,0]
                },
              ],
              chart: {
                type: "bar",
                height: 350
              },
              plotOptions: {
                bar: {
                  horizontal: false,
                  columnWidth: "55%",
                }
              },
              theme: {
                mode: 'dark', 
                palette: 'palette1', 
                monochrome: {
                    enabled: false,
                    color: '#255aee',
                    shadeTo: 'dark',
                    shadeIntensity: 0.65
                },
            },
              dataLabels: {
                enabled: false
              },
              stroke: {
                show: true,
                width: 2,
                colors: ["transparent"]
              },
              xaxis: {
                categories: []
              },
              yaxis: {
                title: {
                  text: "₺ (Tutar)"
                }
              },
              fill: {
                opacity: 1
              },
              tooltip: {
                y: {
                  formatter: function(val) {
                    return "₺" + val + "Tl";
                  }
                }
              }
          };

        this.chartOptionsProductivity = {
            series: [
                {
                  name: "Tasarruf",
                  data: [0,0]
                }
              ],
              chart: {
                type: "area",
                height: 350,
                zoom: {
                  enabled: false
                }
              },
              dataLabels: {
                enabled: false
              },
              stroke: {
                curve: "straight"
              },
        
              title: {
                text: "Ulaşılan Max Doluluk",
                align: "left"
              },
              labels: [],
              xaxis: {
                type: "category"
              },
              yaxis: {
                opposite: true
              },
              legend: {
                horizontalAlign: "left"
              }
          };
    }


    public async ngOnInit() {
        this.companyId = parseInt(localStorage.getItem("CompanyID"));
        await this.getCompanies();

        if(this.companyId==1){
            this.companyId = this.companies.find(x=>x.id !=1).id;
        }

        this.onTimeChangeClick("year");
        this.updateTableDataSource()
    }

    public async getGeneralReportList(){
        try {
            this._generalReport = await this._generalReportService.getGeneralReport(this.companyId,this.StartTime,this.EndTime,this.selectByFilter);
        } catch (error) {
            console.warn(error);
        }
    }

    setWidgetData(){
        this.widgetOptimizeCost =0;
        this.widgetBaseCost =0;
        this.widgetTotalContainer =0;
        this.widgetTotalOptimize =0;
        this.widgetTotalSaving =0;

        this._generalReport.forEach(x=>{
            this.widgetOptimizeCost += x.totalOptimizeCost;
            this.widgetBaseCost += x.totalBaseCost;
            this.widgetTotalContainer += x.totalContainerCount;
            this.widgetTotalOptimize += x.totalOptimizeCount;
            this.widgetTotalSaving += x.totalSavingTotal;
        })
    }

    private async getCompanies(){
        try {
            this.companies = await this._companyService.getCompanies();
        } catch (error) {
            console.warn(error);
        }
    }

    // public async onReportClick() {
    //     const columns = ["No","Konteyner Adı", "Cihaz id", "Tarih","Boşaltılmadan Önce Tarih","Boşaltılmadan Sonra Tarih" ,"Boşaltılmadan Önce", "Boşaltıldıktan Sonra", "Adres"];
    //     let idx = 1;
    //     const dataset = this._generalContainerReport.map(p => {
    //         return {
    //             index: idx++,
    //             name: `${p.containerName}`,
    //             cihazId: `${p.deviceId}`,
    //             beforetarih: `${p.beforeDate}`,
    //             aftertarih: `${p.afterDate}`,
    //             dolulukOnce: `${p.beforeOccupancy}`,
    //             dolulukSonra: `${p.afterOccupancy}`,
    //             Address: `${p.address}`,

    //         }
    //     });
    //     this._excelService.exportAsExcelFile(
    //         columns,
    //         dataset,
    //         'Çöp Boşaltım Raporu',
    //         "",
    //         new Date(),
    //         {
    //             worksheetName: 'Çöp Boşaltım Raporu'
    //         }
    //     );
    // }

    public onTimeChangeClick(key: string, startTime?: Date, endTime?: Date) {
        switch (key) {
            case "day":
                var end = new Date();
                var start = new Date(end.getFullYear(),end.getMonth(),end.getDate()-1,0,0);
                this.StartTime = start;
                this.EndTime = end
                this.selectByFilter = key;
                break;
            case "year":
                var end = new Date();
                var start = new Date(end.getFullYear(),0,1,0,0);
                this.StartTime = start;
                this.EndTime = end
                this.selectByFilter = key;

                break;
            case "month":
                var end = new Date();
                var start = new Date(end.getFullYear(),end.getMonth(),1,0,-1);
                this.StartTime = start;
                this.EndTime = end
                this.selectByFilter = key;
                break;

            default:
                this.StartTime = startTime;
                this.EndTime = endTime
                this.selectByFilter = key;
                break;
        }
        this.refresh();
    }

    private async updateTableDataSource(): Promise<void> {
        this._dataSource = new MatTableDataSource<GeneralReport>(this._generalReport);
        this._dataSource.paginator = this._paginator;
        this._dataSource.sort = this._sort;
    }

    public async setCostChart(){
        var dataBase = [];
        var dataOptimize = [];
        var dataMileageSavingCost = [];
        var dataTimeSavingCost = [];
        var dataSavingTotal = [];
        var dataBase = [];
        var label = [];
        this._generalReport.forEach(x=>{
            dataBase.push(x.totalBaseCost.toFixed(2));
            dataOptimize.push(x.totalOptimizeCost.toFixed(2));
            dataMileageSavingCost.push(x.totalMileageSavingsCost.toFixed(2));
            dataTimeSavingCost.push(x.totalTimeSavingsCost.toFixed(2));
            dataSavingTotal.push(x.totalSavingTotal.toFixed(2));
            label.push(x.created_at?this._datePipe.transform(x.created_at,"dd.MM.yyyy"):"");
        });
        this.chartOptionsCost = {
            series: [
                {
                  name: "Klasik Maliyet",
                  data: dataBase
                },
                {
                  name: "Gerçekleşen Maliyet",
                  data: dataOptimize
                },
                {
                  name: "Kilometreden Yakıt Tasarrufu",
                  data: dataMileageSavingCost
                },
                {
                  name: "Zamandan Yakıt Tasarrufu",
                  data: dataTimeSavingCost
                },
                {
                  name: "Toplam Tasarruf",
                  data: dataSavingTotal
                },
              ],
              chart: {
                type: "bar",
                height: 350
              },
              plotOptions: {
                bar: {
                  horizontal: false,
                  columnWidth: "55%",
                }
              },
              theme: {
                mode: 'dark', 
                palette: 'palette1', 
                monochrome: {
                    enabled: false,
                    color: '#255aee',
                    shadeTo: 'dark',
                    shadeIntensity: 0.65
                },
            },
              dataLabels: {
                enabled: false
              },
              stroke: {
                show: true,
                width: 2,
                colors: ["transparent"]
              },
              xaxis: {
                categories: label
              },
              yaxis: {
                title: {
                  text: "₺ (Tutar)"
                },
                min:0
              },
              fill: {
                opacity: 1
              },
              tooltip: {
                y: {
                  formatter: function(val) {
                    return "₺" + val + "TL";
                  }
                }
              }
          };

    }

    public async setProductivityChart(){
        var data = [];
        var label = [];
        this._generalReport.forEach(x=>{
            data.push(100-x.productivity);
            label.push(x.created_at?this._datePipe.transform(x.created_at,"dd.MM.yyyy"):"");
        });
        this.chartOptionsProductivity = {
            series: [
                {
                  name: "Tasarruf",
                  data: data
                }
              ],
              chart: {
                type: "area",
                height: 350,
                zoom: {
                  enabled: false
                }
              },
              theme: {
                mode: 'dark', 
                palette: 'palette1', 
                monochrome: {
                    enabled: false,
                    color: '#255aee',
                    shadeTo: 'dark',
                    shadeIntensity: 0.65
                },
            },
              dataLabels: {
                enabled: false
              },
              
              stroke: {
                curve: "straight"
              },
              labels: label,
              xaxis: {
                type: "category"
              },
              yaxis: {
                opposite: false,
                max:100,
                min:0
              },
              legend: {
                horizontalAlign: "left"
              }
          };
    }
    public onTableRowChange(element:GeneralReport){
        var startTime = new Date(element.created_at);
        var endTime = new Date(element.created_at);
        endTime.setMonth(endTime.getMonth() + 1);
        this.router.navigate(
            ["apps/general-zone-report-list"],
                { 
                    queryParams: 
                        {
                            "start_date":this._datePipe.transform(startTime,"dd.MM.yyyy"),
                            "end_date":this._datePipe.transform(endTime,"dd.MM.yyyy")
                        }
                    })
    }

    public async refresh(){
        await this.getGeneralReportList();
        await this.updateTableDataSource();
        this.setWidgetData();
        this.setCostChart();
        this.setProductivityChart();
    }
}
